import axios from "../axiosClient";

export const getTownCouncils = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/TC/getall`, {
    params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    signal,
  });

  return res?.data;
};

export const getAllTownCouncils = async (
  signal: any,
  PageNumber: any = 0,
  pageSize: any = 0
) => {
  const res = await axios.get(`/slpapp/TC/getall`, {
    params: { PageNumber, pageSize },
    signal,
  });

  return res?.data;
};
